import { useState } from "react";
import { useAnimation } from "framer-motion";

export const useDynamicImageControls = () => {
  const [controlsDynamicNoise] = useState(useAnimation());
  const [controlsDynamicImage] = useState(useAnimation());
  const [controlsDynamicTitle] = useState(useAnimation());

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const cardRect = e.currentTarget.getBoundingClientRect();
    const offsetX = ((clientX - cardRect.left) / cardRect.width - 0.5) * 50;
    const offsetY = ((clientY - cardRect.top) / cardRect.height - 0.5) * 100;

    // Image Motion Controls
    controlsDynamicImage.start({
      x: offsetX,
      y: offsetY,
      scale: 1.2,
      transition: { duration: 1 },
    });
  };

  const handleMouseDown = () => {
    // Noise
    controlsDynamicNoise.start({
      opacity: 1,
      transition: { duration: 0.5 },
    });

    // Title Motion Controls
    controlsDynamicTitle.start({
      x: 0,
      y: -60,
      transition: { duration: 0.5 },
    });
  };

  const handleMouseLeave = () => {
    // Noise
    controlsDynamicNoise.start({
      opacity: 0,
      transition: { duration: 0.5 },
    });

    // Image Motion Controls
    controlsDynamicImage.start({
      x: 0,
      y: 0,
      scale: 1,
      transition: { duration: 1 },
    });

    // Title Motion Controls
    controlsDynamicTitle.start({
      x: 0,
      y: 0,
      transition: { duration: 0.5, ease: "backOut" },
    });
  };

  return {
    controlsDynamicNoise,
    controlsDynamicImage,
    controlsDynamicTitle,
    handleMouseMove,
    handleMouseDown,
    handleMouseLeave,
  };
};
